import { useEffect, useRef } from "react";

// this hook will stop the scroll if the parameter "isModalOpen" is true.
// it will also REMEMBER and mantain the scroll position once "isModalOpen is false".
// this should be called by any components that open a modal. it is the best way to freeze scroll.
export const useStopScroll = (isModalOpen) => {
  const scrollPosition = useRef(0);

  useEffect(() => {
    if (isModalOpen) {
      // Store current scroll position
      scrollPosition.current = window.scrollY;

      // Freeze scrolling by setting body position fixed
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollPosition.current}px`;
      document.body.style.width = "100%";
    } else {
      // Restore scrolling when modal closes
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";

      // Restore previous scroll position
      window.scrollTo(0, scrollPosition.current);
    }
  }, [isModalOpen]);
};

export default useStopScroll;
